/**
 * employeeScheduleSearch.ts
 * Comprehensive free-text matcher for the Employee Schedule (UX overhaul).
 * A row survives if every whitespace-separated token appears somewhere in the
 * person's profile OR any of their assignment bars (task, WO#, quote#, machine,
 * kind, status).
 */

import type { EmployeeBar, EmployeeBarUser } from '../services/scheduleEmployeeBars';

export function matchesEmployeeSearch(
  query: string,
  user: EmployeeBarUser,
  bars: EmployeeBar[],
): boolean {
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const parts: Array<string | null> = [
    user.displayName, user.jobClass, user.tier, user.workGroup, user.email,
  ];
  for (const b of bars) {
    parts.push(b.name, b.workOrderNo, b.quoteNumber, b.machineCode, b.kind, b.status, b.projectId);
  }
  const hay = parts.filter(Boolean).join(' ').toLowerCase();
  return tokens.every((t) => hay.includes(t));
}
